// extracted by mini-css-extract-plugin
module.exports = {"Container":"📚4-7-02FmyM","Dialog":"📚4-7-02TMKu"};